import styled from 'styled-components';
import { shade } from 'polished';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 80vw;
  height: 80vh;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  position: relative;

  @media (max-width: 768px) {
    width: 85vw;
    height: 75vh;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    width: 90vw;
    height: 80vh;
    border-radius: 6px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #f5f5f5;

  h2 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover {
    background: #e0e0e0;
    color: #333;
  }
`;

export const CameraContainer = styled.div`
  flex: 1;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    min-height: 300px;
  }

  @media (max-height: 600px) {
    min-height: 250px;
  }

  @keyframes scan {
    0% {
      top: 0;
    }
    50% {
      top: calc(100% - 2px);
    }
    100% {
      top: 0;
    }
  }
`;

export const Controls = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  background: #f5f5f5;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 480px) {
    padding: 16px;
    gap: 8px;
  }
`;

export const CaptureButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #01579b;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, '#01579b')};
  }

  &:active {
    transform: scale(0.98);
  }

  &.barcode {
    background: #4caf50;

    &:hover {
      background: ${shade(0.2, '#4caf50')};
    }
  }

  &.scanning {
    background: #ff5722;
    animation: pulse 1.5s infinite;

    &:hover {
      background: ${shade(0.2, '#ff5722')};
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }

  svg {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    padding: 10px 20px;
    font-size: 14px;

    svg {
      font-size: 16px;
    }
  }
`;
